module.exports = __webpack_public_path__ + "img/sheb.eb3c0396.jpg";